import React, { Component } from 'react';
import classSet from 'react-classset';
import { getComponentContent, loadVideo } from '../../helpers';
const playIcon = process.env.REACT_APP_IMAGES_ROOT + 'ssc-play-2.png';

class VideoPlayer extends Component {

	constructor() {
    super();
    this.state = {
      loaded: false,
      paused: true
    }
    this.togglePlaying = this.togglePlaying.bind(this);
    this.content = getComponentContent('VideoPlayer');
  }

  componentWillMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

	componentDidMount() {
    this.video.textTracks[0].mode = 'showing';
		if (this.props.playsInline) {
	    this.video.setAttribute('playsinline', 'playsinline');
	  } else {
	  	this.video.setAttribute('controls','controls');
	  }
	  const self = this;
	  if (this.video.readyState === 4) {
      this.setState({loaded: true});
    } else if (this.props.playsInline) {
      loadVideo(this.video, () => {
        self.setState({loaded: true});
      });
    }
    this.video.addEventListener('playing', () => {
      if (self.mounted) {
        self.setState({paused: false});
      }
    }, false);
    this.video.addEventListener('pause', () => {
      if (self.mounted) {
        self.setState({paused: true});
      }
    }, false);
    this.video.addEventListener('ended', () => {
      //do something when video ends?
    }, false);
	}

	togglePlaying() {
		if (this.state.paused) {
			this.video.play();
		} else {
			this.video.pause();
		}
	}

  render() {

  	const videoClasses = classSet({
  		'ssc__video-player': true,
  		'ssc__video-player--paused': this.state.paused
  	});

    return (

      <div className={videoClasses} style={this.props.customStyle} onClick={this.togglePlaying}>
      	{this.state.paused && this.props.playsInline &&
      		<img src={playIcon} alt={this.content.playAlt} />
      	}
        <video muted poster={this.props.poster} controlsList="nodownload" ref={el => this.video = el}>
        	<source src={this.props.src} type="video/mp4" />
          <track default src={this.props.captions} />
        </video>
      </div> 

    );

  }

}

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.js